export function getValueHelper(state, value) {
    return state ? value : undefined;
}
//# sourceMappingURL=getValueHelper.js.map